import { useResponsiveValue } from "@theme-ui/match-media";
import { 
    Box,
    Flex,
    Text,
    Badge,
    NavLink as ThemedNavLink,
} from "theme-ui";

export const Summary = ({institution, user}) => {
    const isMobile = useResponsiveValue([true, true, true, false]);

    return (
        <Box bg="light" sx={{
            boxShadow: '3px 3px 20px rgba(29, 43, 43, 0.1)',
            borderRadius: '20px'
        }}>
            <Box bg="white" p={4} sx={{
                boxShadow: '3px 3px 20px rgba(29, 43, 43, 0.1)',
                borderRadius: '20px'
            }}>
                <Flex sx={{
                    flexDirection: 'column',
                    gap: [2, null, null, 5],
                }}>
                    <Flex sx={{
                        justifyContent: ['left', 'left', 'left', 'space-between'],
                    }}>
                        <Flex sx={{ flexDirection: 'column' }}>
                            <Badge sx={{ width: 'fit-content' }} variant='profile'>{user?.first_name} {user?.last_name}</Badge>
                            <Text as={isMobile ? "h3" : "h2"}>
                                {institution?.name}
                            </Text>
                            <Text variant='smallLight'>AFSL: {institution.afsl}</Text>
                            <Text variant='smallLight'>PID: {institution.pid}</Text>
                        </Flex>
                        {!isMobile && (
                            <Flex as="nav" sx={{
                                backgroundColor: 'tealLighter',
                                borderRadius: '9999px',
                                height: 'fit-content',
                                width: 'fit-content',
                            }}>
                                <ThemedNavLink 
                                    sx={{
                                        height: '22px',
                                        backgroundColor: 'tealLighter',
                                        borderRadius: '9999px',
                                        margin: '2px',
                                        color: 'tealDark'
                                    }}
                                >
                                    Institutional
                                </ThemedNavLink>
                            </Flex>
                        )}
                    </Flex>

                </Flex>
            </Box>
        </Box>
    )
}